const theme = {
  red: "#FFC09F",
  orange: "#FFD799",
  darkYellow: "#FFEE93",
  lightYellow: "#FCF5C7",
  cream: "#F5FFFA",
  blue: "#A0CED9",
  lightGreen: "#ADF7B6",
  darkGreen: "#05380C",
  brown: "#412F1F",
  gray: "#676767",
};
export default theme;
